<template>
  <div
    class="menucontrol-scroll fixed-top w-full mx-auto lg:py-12 md:py-12 py-8 lg:px-12 md:px-12 px-6"
  >
    <div class="flex w-full justify-between">
      <div class="text-left lg:w-7/12 md:w-7/12 w-3/4">
        <h2
          class="lg:font-semibold md:font-semibold font-bold lg:text-3xl md:text-3xl text-xl"
        >
          We’re ready! Here’s a brief summary of your project based on your
          requirements
        </h2>
        <p class="mt-2 lg:text-xl md:text-xl text-sm text-303030">
          Hooray!
          <b> {{ completePercentage ? completePercentage : 0 }}% </b> of your
          project can be auto-developed by CERA. Visit the lounge to schedule a
          kick-off call to get things rolling.
        </p>
      </div>

      <div class="lg:w-5/12 md:w-5/12 w-1/4 flex justify-end">
        <img
          src="@/assets/images/loungeimage.png"
          alt="image"
          class="summaryw-150px"
        />
      </div>
    </div>

    <div class="flex items-center mt-4">
      <vs-button
        @click="reScope"
        color="secondary"
        class="font-semibold lg:px-16 md:px-16 px-6 fsize14 sm-fsize12 lg:py-5 md:py-5 py-4 rounded-full lg:mr-3 md:mr-3 mr-2"
        >Re-Scope
      </vs-button>
      <vs-button
        :disabled="loungeClicked"
        id="loungeButton"
        @click="successResponse"
        class="vs-con-loading__container font-semibold lg:px-16 md:px-16 px-6 fsize14 sm-fsize12 lg:py-5 md:py-5 py-4 rounded-full lg:ml-3 md:ml-3 ml-2"
        >Save Project</vs-button
      >
    </div>
    <div class="lg:flex md:flex mt-12">
      <vx-card
        class="lg:w-1/2 md:w-1/2 rounded20 bg-white shadow lg:mb-0 md:mb-0 mb-6 p-6 lg:mr-4 md:mr-4"
      >
        <div class="mb-10 inlinetable">
          <h2 class="text-303030 fsize24 sm-fsize14 font-semibold lg:mb-6 mb-3">
            Project Suite
          </h2>
          <div class="flex flex-wrap">
            <p
              class="fsize14 sm-fsize12 px-5 py-2 text-warning rounded-full text-center light-chipswarning m-2"
              v-for="suites in allSuites"
              :key="suites._id"
            >
              {{ suites.name }}
            </p>
          </div>
        </div>

        <div class="mb-10">
          <h2 class="text-303030 fsize24 sm-fsize14 font-semibold lg:mb-6 mb-3">
            User Roles
          </h2>
          <div class="flex flex-wrap">
            <!-- <p
              v-for="(role, index) in selectedID === 2
                ? userSelectedRoles
                : allRoles"
              :key="'role' + index"
              class="fsize14 px-5 py-2 rounded-full text-center m-2"
              :class="[
                role._id
                  ? 'bg-light-primary text-primary'
                  : 'bg-primary text-white',
                role.isRecommendation ? 'bg-secondary' : '',
              ]"
            >
              {{ role.role }}
            </p> -->
            <p
              v-for="Roles in allUserRoles"
              :key="Roles.role"
              class="fsize14 bg-light-primary text-primary px-5 py-2 rounded-full text-center m-2"
            >
              {{ Roles.role }}
            </p>
          </div>
        </div>

        <div class="mb-10">
          <h2 class="text-303030 fsize24 sm-fsize14 font-semibold lg:mb-6 mb-3">
            Features
          </h2>
          <div class="flex flex-wrap">
            <p
              v-for="pages in allPages"
              :key="pages.page"
              class="fsize14 px-5 py-2 m-2 text-info rounded-full text-center bg-f4f5f6"
            >
              {{ pages.page }}
            </p>
          </div>
        </div>
      </vx-card>

      <vx-card
        class="lg:w-1/2 md:w-1/2 rounded20 bg-white shadow p-6 lg:ml-4 h-full md:ml-4"
      >
        <div class="text-left w-4/5">
          <h2 class="font-semibold sm-fsize20 fsize24">User Stories</h2>
          <p class="mt-2 fsize18 text-929292 sm-fsize12">
            Your requirements are translated into userstories that help you
            identify user roles, Pages & user activities.
          </p>
        </div>

        <div class="mt-6 lg:flex items-center gap-3">
          <div class="lg:w-1/2 flex w-full items-center">
            <div class="w-2/12">
              <p class="text-303030 fsize16 items-center font-semibold">As a</p>
            </div>
            <div class="w-10/12">
              <select v-model="selectedRole" class="userselect-pad py-2 mx-2">
                <option
                  v-for="Role in allUserRoles"
                  :key="Role.role"
                  :value="Role"
                >
                  {{ Role.role }}
                </option>
              </select>
            </div>
          </div>
          <div class="lg:w-1/2 flex w-full lg:mt-0 mt-2 items-center">
            <div class="w-2/12">
              <p class="text-303030 fsize16 items-center font-semibold">On</p>
            </div>
            <div class="w-10/12">
              <select v-model="selectedPage" class="userselect-pad py-2 mx-2">
                <option v-for="page in allPages" :key="page.page" :value="page">
                  {{ page.page }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="primaryborder-set mt-8 rounded-12px">
          <h2
            class="font-semibold fsize16 bg-f8eef7 hrad-radround text-primary p-4"
          >
            The {{ selectedRole && selectedRole.role }} can...
          </h2>

          <ul class="scrollbar35 p-1" v-if="stories.length">
            <li
              class="fsiz12 p-3 lightbottom-b cursor-pointer"
              v-for="(story, index) in stories"
              :key="story._id"
            >
              {{ index + 1 }}. {{ story.description }}
            </li>
          </ul>
          <ul class="p-1" v-else>
            <li>No Data Found</li>
          </ul>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import { mapState } from "vuex";
import jwt from "jsonwebtoken";

export default {
  data() {
    return {
      selectedRole: [],
      selectedPage: [],
      allUserRoles: [],
      allPages: [],
      allSuites: [],
      stories: [],
      loungeClicked: false,
      claim: "",
      Hello_Url: process.env.VUE_APP_BRAINED_API_URL,
      tasklist: "",
      additionalPagesForPercent: "",
      suitePagesForPercent: "",
    };
  },

  methods: {
    async loungeBtn() {
      if (this.selectedPlan.plan.name !== "Free") {
        // yearly
        let duration = 12;
        let price = this.selectedPlan.billing.price * duration;
        let gst = price * 100 * 0.18;
        const { data } = await Axios.post(
          `${this.Hello_Url}brained/payment/create_order`,
          {
            amount: price * 100 + gst,
            currency: "INR",
          }
        );

        const options = {
          // key: process.env.VUE_APP_RAZORPAY_KEY,
          currency: "INR",
          order_id: data.id,
          prefill: {
            email: this.userDetails.email,
          },
          handler: async (response) => {
            await this.successResponse();
          },
        };

        const rzp = await new Razorpay(options);
        rzp.open();
      } else {
        await this.successResponse();
      }
    },
    async successResponse() {
      console.log("clicked");
      this.loungeClicked = true;
      this.$vs.loading({
        container: "#loungeButton",
        scale: 0.45,
      });
      await this.createProject();
      console.log("1111111111111");
      await this.setUserPlans();
      console.log("11111111111112");
      await this.createDefaultVersion();
      console.log("11111111111113");
      await this.addRolesToProject();
      console.log("11111111111114");
      await this.addPagesToProject();
      console.log("11111111111115");
      // await this.addStoriestoProject();
      // // this.startAutoDeploy();
      this.$store.commit("scope/SET_IS_CHECKED_OUT", true);
      let prefill = {
        email: this.userDetails.email,
        name: this.userDetails.username,
        plan: this.selectedPlan.plan.name,
        projectName: this.userDetails.projectName,
      };
      const { data } = await Axios.post(
        `${this.Hello_Url}brained/send/paymentEmail`,
        prefill
      );
      this.$store.commit("scope/SET_PROJECT_NAME", "");
      this.$store.commit("scope/SET_FLAG", "");
      setTimeout(() => {
        this.$vs.loading.close("#loungeButton > .con-vs-loading");
        this.loungeClicked = false;
      }, 3000);
      this.$router.push({ name: "custom-project-management" });

      // this.$router.push({ name: "lounge-page" });
    },
    async addRolesToProject() {
      let payload = {
        addRoles: this.allUserRoles,
        projectId: this.userDetails.projects[0]._id,
        projectName: this.userDetails.projects[0].projectName,
        taskListID: this.tasklist._id,
      };
      await this.$store.dispatch("scope/addRolesToProject", payload);
    },

    async addPagesToProject() {
      let payload = {
        addPages: this.allPages,
        projectId: this.userDetails.projects[0]._id,
        projectName: this.userDetails.projects[0].projectName,
        taskListID: this.tasklist._id,
      };
      await this.$store.dispatch("scope/addPagesToProject", payload);
    },
    async setUserPlans() {
      let payload = {
        projectName: this.projectName.trim().replace(/ /g, "-").toLowerCase(),
        projectId: this.userDetails.projects[0]._id,
        subscription: this.selectedPlan.plan._id,
        plan: this.selectedPlan.billing,
        payment_status: "Paid",
        manHours: `${this.selectedPlan.billing.boosters}`,
      };
      await this.$store.dispatch("billing/addBilling", payload);
    },
    async createDefaultVersion() {
      const payload = {
        projectId: this.userDetails.projects[0]._id,
      };
      let { data } = await this.$store.dispatch(
        "scope/defaultProjectVersion",
        payload
      );
      console.log(data, "datain tas");
      this.tasklist = data.data;

      console.log(this.tasklist, "TAS");
    },
    async createProject() {
      this.$vs.loading();
      if (!this.userDetails.projects.length) {
        this.authCheck();
        const addPayload = {
          userID: this.userDetails._id,
          projectName: this.projectName,
          location:
            this.selectedProject.countryCode.iso2 == "SG" ? "Singapore" : "",
          displayName: this.projectName,
          businessName: this.projectName,
          mobile: this.claim.userMobile,
          resellerId: this.login.reseller,
          adminLink: this.projectName.trim().replace(/ /g, "-").toLowerCase(),
          source: this.offerActivated
            ? "Reseller Offer"
            : this.resellerLead
            ? "Reseller"
            : "Website",
        };

        await this.$store.dispatch("scope/createProject", addPayload);

        await this.setUserSuites();

        const userData = {
          email: this.userDetails.email.toLowerCase(),
        };
        const { data } = await Axios.post(
          `${this.Hello_Url}brained/user/viewUser`,
          userData
        );
        console.log(data);
        const userD = { ...data.result.projects[0], ...data.result };

        this.$store.commit("scope/SET_TOKEN", data.token);
        this.$store.commit("scope/SET_USER_DETAILS", userD);
        localStorage.setItem("token", data.token);
      }

      if (this.userDetails.projects.length) {
        const payload = {
          mobile: this.claim.userMobile,
          projectName: this.projectName,
        };
        await Axios.post(
          `${this.Hello_Url}brained/user/addScopeRequirements`,
          payload
        );
        this.$vs.loading.close();
      }
    },
    async setUserSuites() {
      this.$vs.loading();
      let suitesData = [];

      this.suites.forEach((item) => {
        let obj = {
          _id: item._id,
          img: item.suiteImage,
          title: item.name,
          selectStatus: false,
          keywords: item.keywords,
          type: item.type,
        };
        suitesData.push(obj);
      });

      const payload = {
        mobile: this.claim.userMobile,
        suites: suitesData,
      };
      await Axios.post(
        `${this.Hello_Url}brained/user/addScopeRequirements`,
        payload
      );
      this.$vs.loading.close();
    },
    async getStories() {
      if (Object.keys(this.selectedPage).length > 0) {
        let Payload = {
          pages: [this.selectedPage._id],
          roles: [this.selectedRole._id],
          story: true,
        };
        let data = await this.$store.dispatch("scope/getStories", Payload);
        this.stories = data.data.data;
      }
    },
    reScope() {
      this.$router.push({ name: "scope-Requirements" });
    },
    async filterPages() {
      let feature = [];
      let demo = [];
      for (let i = 0; i < this.selectedSuiteData.length; i++) {
        if (this.selectedSuiteData[i].pages)
          feature.push(this.selectedSuiteData[i].pages);
      }
      for (let i = 0; i < feature.length; i++) {
        demo = demo.concat(feature[i]);
      }
      let temp = await this.filterDuplicates(demo);
      this.allPages = temp.concat(this.allPages);
      this.allPages = await this.filterDuplicates(this.allPages);

      this.selectedPage = this.allPages[0];
    },
    async filterUserRoles() {
      let feature = [];
      let demo = [];
      for (let i = 0; i < this.selectedSuiteData.length; i++) {
        if (this.selectedSuiteData[i].roles)
          feature.push(this.selectedSuiteData[i].roles);
      }
      for (let i = 0; i < feature.length; i++) {
        demo = demo.concat(feature[i]);
      }
      let temp = await this.filterDuplicates(demo);
      this.allUserRoles = temp.concat(this.allUserRoles);
      this.allUserRoles = await this.filterDuplicates(this.allUserRoles);
      this.selectedRole = this.allUserRoles[0];

      await Axios.post(
        `${this.Hello_Url}brained/user/addScopeRequirements`,
        this.allUserRoles
      );
    },
    // for speech to text sentence which gave roles  and pages from gpt
    DivideRecomendation() {
      for (let i = 0; i < this.recommendations.length; i++) {
        if (this.recommendations[i].types == "Roles") {
          this.allUserRoles.push(this.recommendations[i]);
        } else if (this.recommendations[i].types == "PAGES") {
          this.allPages.push(this.recommendations[i]);
        }
      }
    },
    async recommendationPagesFilter() {
      let unfilterPages = this.allPages;
      const uniquenames = {};
      const uniqueObjects = [];
      for (const obj of unfilterPages) {
        if (!uniquenames[obj.page]) {
          uniquenames[obj.page] = true;
          uniqueObjects.push(obj);
        }
      }
      this.allPages = uniqueObjects;
    },
    async recommendationRolesFilter() {
      let unfilterRoles = this.allUserRoles;
      const uniquenames = {};
      const uniqueObjects = [];
      for (const obj of unfilterRoles) {
        if (!uniquenames[obj.role]) {
          uniquenames[obj.role] = true;
          uniqueObjects.push(obj);
        }
      }
      this.allUserRoles = uniqueObjects;
    },

    // give array set ,just pass array
    filterDuplicates(arr) {
      const uniqueSet = new Set(arr.map((item) => JSON.stringify(item)));
      return Array.from(uniqueSet).map((item) => JSON.parse(item));
    },
    authCheck() {
      const token1 = localStorage.getItem("token");
      if (token1) {
        this.claim = jwt.verify(
          token1,
          "TWFnaXR0IENvbnN1bHRhbmN5IHNlcnZlcyBidXNpbmVzc2VzIGluIGFsbCBtYWpvciBzZWN0b3JzLHByb3ZpZGluZyBleGNlcHRpb25hbCBzb2Z0d2FyZSBzb2x1dGlvbnMgZm9yIGxhcmdlIGNvcnBvcmF0aW9ucyxtaWQtc2l6ZWQgZW50ZXJwcmlzZXMsYW5kIHN0YXJ0dXAuundefined"
        );
      }
      console.log(this.claim);
      // if (this.claim) {
      // login not used anywhere
      //   this.loginactive = false;
      // }
    },
    async addDefaultPages() {
      let defaultPages = await this.$store.dispatch("scope/getDefaultPages");
      this.$store.commit("scope/SET_DEFAULT_PAGES", defaultPages.data.data);
    },
    async urlFlag() {
      let flag = {
        mobile: this.claim.userMobile,
        flag: "summary-report",
      };
      await Axios.post(`${this.Hello_Url}brained/user/userFlag`, flag);

      this.$store.commit("scope/SET_FLAG", flag.flag);
    },
  },

  computed: {
    ...mapState("scope", [
      "suites",
      "recommendations",
      "selectedSuiteData",
      "selectedPlan",
      "userDetails",
      "projectName",
      "resellerLead",
      "completePercentage",
      "offerActivated",
    ]),
    ...mapState("admin", ["login"]),
    ...mapState("user", ["selectedProject"]),
    async completed() {
      let percent = 95;
      if (this.additionalPagesForPercent == 0) {
        percent = 95;
      } else if (
        (this.additionalPagesForPercent / this.suitePagesForPercent) * 100 ===
        100
      ) {
        percent = 95;
      } else if (
        (this.additionalPagesForPercent / this.suitePagesForPercent) * 100 <
        28
      ) {
        percent = 28;
      } else {
        (this.additionalPagesForPercent / this.suitePagesForPercent) * 100;
      }
      this.$store.commit("scope/SET_PERCENTAGE", parseInt(percent));
      let payload = {
        mobile: this.claim.userMobile,
        completePercentage: percent,
      };
      Axios.post(`${this.Hello_Url}brained/user/addScopeRequirements`, payload);
      return parseInt(percent);
    },
  },
  async mounted() {
    console.log(this.recommendations, "recommandation we awant");
    this.allSuites = this.suites;
    await this.authCheck();
    await this.DivideRecomendation();
    this.additionalPagesForPercent = this.allPages.length;
    await this.filterUserRoles();
    await this.filterPages();
    this.suitePagesForPercent =
      this.allPages.length - this.additionalPagesForPercent;
    await this.recommendationPagesFilter();
    await this.recommendationRolesFilter();
    await this.addDefaultPages();
    // await this.urlFlag();
  },
  watch: {
    async selectedPage(newval) {
      await this.getStories();
    },
    async selectedRole(newval) {
      await this.getStories();
    },
  },
};
</script>
<style>
.vuesax-app-is-ltr .vs-chip--text {
  margin-left: 0px !important;
}
.vs-input--placeholder.normal {
  padding: 13px !important;
}
border-card {
  border-style: solid;
  border-color: #830c81;
  border-width: 4px;
}

.cust-builder-swiper {
  width: 119px;
}
</style>
